// Search & Discovery's storefront search applies typo tolerance and can return a page of
// loosely-related products even when none of them are true matches. The predictive search
// suggest endpoint scores relevance more strictly, so we use it here to confirm whether a
// search term has any real product matches and swap in the curated no-results state if not.
(function () {
  var resultsWrapper = document.querySelector('[data-search-results-wrapper]');
  var noResults = document.querySelector('[data-search-no-results]');

  if (!resultsWrapper || !noResults) return;
  if (resultsWrapper.hasAttribute('data-search-empty')) return;

  var term = resultsWrapper.getAttribute('data-search-term');
  if (!term) return;

  fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=1')
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      var products = data && data.resources && data.resources.results && data.resources.results.products;

      if (!products || products.length === 0) {
        resultsWrapper.hidden = true;
        noResults.hidden = false;
      }
    })
    .catch(function () {
      // Leave the server-rendered results in place if the relevance check fails.
    });
})();
